
(function () {
if (window.__hhPdpTweaks) return;
window.__hhPdpTweaks = true;
var HH = window.HH_TIERS || {};
var root = document.querySelector('[data-hh-tiers]');
function money(c) { return '$' + (c / 100).toFixed(2); }
function noSku(s) { return String(s || '').replace(/\s*\([^)]*\)/g, '').replace(/\s+/g, ' ').trim(); }
function patchGift() {
Array.prototype.forEach.call(document.querySelectorAll('.hh-t-gpinfo b'), function (b) {
var name = b.textContent.replace(/^.*?free pack\s*[—–-]\s*/i, '').replace(/\s*\(.*?\)\s*$/, '').trim();
if (name && b.textContent !== name) b.textContent = name;
});
Array.prototype.forEach.call(document.querySelectorAll('.hh-t-gpfree'), function (free) {
if (free.querySelector('s')) return;
var m = (free.textContent || '').match(/\$[\d.]+/);
free.innerHTML = 'FREE' + (m ? ' <s>' + m[0] + '</s>' : '');
});
}
function patchFreq() {
Array.prototype.forEach.call(document.querySelectorAll('[data-hh-freq] option'), function (o) {
if (/recommended/i.test(o.textContent)) o.textContent = o.textContent.replace(/\(recommended\)/i, '(Popular)');
});
}
function patchFreqLabel() {
var lab = document.querySelector('.hh-t-flabel');
if (!lab || lab.getAttribute('data-hh-lab')) return;
lab.innerHTML = 'Restock every <span class="hh-t-flabel-hint">— No stress, change any time</span>';
lab.setAttribute('data-hh-lab', '1');
}
function patchHint() {
var h = document.querySelector('.hh-t-hint');
if (h && /most tradies/i.test(h.textContent)) {
h.textContent = h.textContent.replace(/^\s*most tradies[^.]*\.\s*/i, '').trim();
}
}
function patchTotals() {
if (!HH.rrp) return;
var countB = document.querySelector('[data-hh-count] b');
var q = countB ? (parseInt(countB.textContent, 10) || 0) : 0;
if (!q) return;
var rrpStr = money(HH.rrp * q);
var oneTot = document.querySelector('.hh-t-optbox[data-mode="one"] .hh-t-opttot');
if (oneTot) {
var s1 = oneTot.querySelector('s');
if (!s1) oneTot.innerHTML = '<s>' + rrpStr + '</s>' + oneTot.textContent.trim();
else if (s1.textContent !== rrpStr) s1.textContent = rrpStr;
}
var s2 = document.querySelector('.hh-t-optbox[data-mode="sub"] .hh-t-opttot s');
if (s2 && s2.textContent !== rrpStr) s2.textContent = rrpStr;
}
function patchNext() {
var next = document.querySelector('.hh-t-next');
if (!next || next.getAttribute('data-hh-next')) return;
var txt = next.textContent || '';
var addM = txt.match(/add\s+(\d+)\s+more/i);
var priceM = txt.match(/\$[\d.]+/);
if (!addM || !priceM) return;
var nextPB = parseFloat(priceM[0].slice(1));
var countSpan = document.querySelector('.hh-t-count span');
var curM = countSpan ? countSpan.textContent.match(/\$[\d.]+/) : null;
var curPB = curM ? parseFloat(curM[0].slice(1)) : null;
var countB = document.querySelector('.hh-t-count b');
var tot = countB ? (parseInt(countB.textContent, 10) || 0) : 0;
var nq = tot + parseInt(addM[1], 10);
var tiers = HH.tiers || [];
var nt = tiers.filter(function (t) { return t.q === nq; })[0] || tiers.filter(function (t) { return t.q > tot; })[0];
var incl = nt ? noSku(nt.incl).replace(/\.\s*$/, '') : '';
var html = 'Add ' + addM[1] + ' more &rarr; ' + priceM[0] + '/box';
if (curPB != null && curPB - nextPB > 0.005) html += ' &middot; save ' + money(Math.round((curPB - nextPB) * 100)) + '/box';
if (incl) html += '<span class="hh-t-unlock" style="display:block;margin-top:3px;line-height:1.3">&#127873; ' + incl + '</span>';
next.innerHTML = html;
next.setAttribute('data-hh-next', '1');
}
function patchRib() {
var card = document.querySelector('.hh-tiers .hh-t-card[data-q="4"]');
if (!card || card.querySelector('.hh-t-rib')) return;
var rib = document.createElement('span');
rib.className = 'hh-t-rib';
rib.textContent = 'STARTER';
var save = card.querySelector('.hh-t-save');
if (save && save.nextSibling) card.insertBefore(rib, save.nextSibling);
else card.insertBefore(rib, card.firstChild);
}
function patchPerks() {
var ul = document.querySelector('.hh-t-perks');
if (!ul || ul.getAttribute('data-hh-perks')) return;
var map = [
['no commitment', '<b>Skip, delay or stop anytime</b>'],
['priority', '<b>Free priority shipping, every time</b>'],
['shipping protection', '<b>Free Shipping Protection</b>'],
['price lock', '<b>Your price locked for life</b>'],
['crew rewards', '<b>Every 30 boxes, one free</b>'],
['money back', '<b>60-day money-back guarantee</b>']
];
var done = 0;
Array.prototype.forEach.call(ul.querySelectorAll('li'), function (li) {
var t = (li.textContent || '').toLowerCase();
for (var i = 0; i < map.length; i++) {
if (t.indexOf(map[i][0]) >= 0) { li.innerHTML = map[i][1]; done++; break; }
}
});
if (done) ul.setAttribute('data-hh-perks', '1');
}
function patchIncl() {
var el = document.querySelector('.hh-t-incl');
if (el && /\([A-Z0-9]+\)/.test(el.innerHTML)) el.innerHTML = el.innerHTML.replace(/\s*\([A-Z0-9]+\)/g, '');
}
function patchAll() { patchGift(); patchFreq(); patchFreqLabel(); patchHint(); patchTotals(); patchNext(); patchIncl(); patchRib(); patchPerks(); }
var EC_TILES = [
['/collections/light-duty', 'Light duty', '//hygienehub.au/cdn/shop/files/bubble-pink-nitrile-gloves-100pcs-nitrile-glove-7156201.jpg?v=1778196312&width=220'],
['/collections/medium-duty', 'Medium duty', '//hygienehub.au/cdn/shop/files/x2245-maxprotect-nitrile-powder-free-examination-gloves-100pcs-nitrile-glove-9220733.png?v=1778196312&width=220'],
['/collections/heavy-duty', 'Heavy duty', '//hygienehub.au/cdn/shop/files/heavy-duty-diamond-textured-gloves-grip-x-nitrile-glove-7856855.png?v=1778196312&width=220']
];
function enhanceDrawer(cd) {
Array.prototype.forEach.call(cd.querySelectorAll('.hh-sub'), function (sub) {
var item = sub.closest('.cart-item');
if (item && sub.parentElement !== item) item.appendChild(sub);
});
var col = cd.querySelector('.cart-drawer__collection');
if (col && !col.querySelector('.hh-ec-duty')) {
var html = '<div class="hh-ec-h">Shop by duty</div><div class="hh-ec-duty">';
EC_TILES.forEach(function (t) {
html += '<a class="hh-ec-tile" href="' + t[0] + '"><img src="' + t[2] + '" alt="' + t[1] + '" loading="lazy"><span>' + t[1] + '</span></a>';
});
col.innerHTML = html + '</div>';
}
}
function initDrawer() {
var cd = document.querySelector('cart-drawer');
if (!cd) return;
enhanceDrawer(cd);
var deb;
new MutationObserver(function () { clearTimeout(deb); deb = setTimeout(function () { enhanceDrawer(cd); }, 60); })
.observe(cd, { childList: true, subtree: true });
}
function initMBG() {
var ps = document.querySelectorAll('.product__column-sticky p.product__text.inline-richtext, .product__info-container p.product__text.inline-richtext');
var p = Array.prototype.filter.call(ps, function (el) { return /money back guarantee/i.test(el.textContent || ''); })[0];
if (!p || p.getAttribute('data-hh-mbg')) return;
p.setAttribute('data-hh-mbg', '1');
p.innerHTML = '🛡️ <strong>30-Day Money Back Guarantee</strong>' +
'<span class="hh-mbg-wrap">' +
'<button type="button" class="hh-mbg-i" aria-label="Money-back guarantee details" aria-expanded="false">' +
'<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="10" cy="10" r="8"/><path d="M10 9v4" stroke-linecap="round"/><circle cx="10" cy="6.4" r=".7" fill="currentColor" stroke="none"/></svg>' +
'</button>' +
'<span class="hh-mbg-pop" hidden><b>How it works.</b> Not the toughest gloves you’ve used? Contact us within 30 days of delivery for a full refund. Set &amp; Forget members get 60 days.</span>' +
'</span>';
var btn = p.querySelector('.hh-mbg-i');
var pop = p.querySelector('.hh-mbg-pop');
btn.addEventListener('click', function (e) {
e.preventDefault();
if (pop.hasAttribute('hidden')) { pop.removeAttribute('hidden'); btn.setAttribute('aria-expanded', 'true'); }
else { pop.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); }
});
document.addEventListener('click', function (e) {
if (!p.contains(e.target)) { pop.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); }
});
}
function boot() {
initMBG();
initDrawer();
if (root) {
patchAll();
new MutationObserver(patchAll).observe(root, { childList: true, subtree: true });
}
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
})();
